import template from './kitchen-area.jade';
import validation from './../../../services/validation';

export default angular.module('cian.addForm.kitchenArea', []).directive('cianAfAboutObjectKitchenArea', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'deviceService',
    function (deviceService) {
      this.isMobile = deviceService.isMobile;
      this.areaMax = 100000;
      this.areaMin = 0;

      this.validation = validation(this.form, 'kitchenArea', {
        parse: 'Введите число',
        max: 'Допустимо не более 5 символов',
        min: 'Площадь должна быть больше 0',
      });
    },
  ],
  controllerAs: 'kitchenArea',
  template,
})).name;
